import React, { createContext, useCallback, useContext, useState } from "react";
import { ErrorNotification } from "../components/ErrorNotification/ErrorNotification";

interface ErrorNotificationContextValue {
    showError: (message: string, title?: string) => void;
}

const ErrorNotificationContext = createContext<ErrorNotificationContextValue | undefined>(undefined);

export const ErrorNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [error, setError] = useState<{ message: string; title: string } | null>(null);

    const showError = useCallback((message: string, title = "Something went wrong") => {
        setError({ message, title });
    }, []);

    const dismiss = useCallback(() => {
        setError(null);
    }, []);

    return (
        <ErrorNotificationContext.Provider value={{ showError }}>
            {children}
            {error && (
                <ErrorNotification
                    title={error.title}
                    message={error.message}
                    onClose={dismiss}
                />
            )}
        </ErrorNotificationContext.Provider>
    );
};

export const useErrorNotification = (): ErrorNotificationContextValue => {
    const ctx = useContext(ErrorNotificationContext);
    if (!ctx) throw new Error("useErrorNotification must be used within ErrorNotificationProvider");
    return ctx;
};
